import React from 'react';

/**
 * Consistent page header for dashboard sections.
 */
const PageHeader = ({ eyebrow, title, description, action }) => {
  return (
    <header className="candor-section-header">
      <div className="candor-section-header-text">
        {eyebrow && <p className="candor-page-eyebrow">{eyebrow}</p>}
        <h2 className="candor-section-title">{title}</h2>
        {description && <p className="candor-section-desc">{description}</p>}
      </div>
      {action && <div className="candor-section-header-action">{action}</div>}
    </header>
  );
};

export default PageHeader;
